import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import styles from './crossRefer.module.css';
import { setcrossStatus, setcrossStock } from '../../redux/crossreferenceSlice';
import SortCrossRefer from '../../components/OtherComps/CrossProductTable/SortCross';
import CatPagination from '../../utils/Pagination';
import { getcrossProductThunk, setcrossProductPage, setCrossProducts } from '../../redux/crossreferenceSlice';
import ProductTable from '../../components/OtherComps/ProductTable/ProductTable';
import { toggleProductSelection } from '../../redux/compareSlice';

const CrossRefer = () => {
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const search = searchParams.get('search') || '';

    const { products, loading, page, status, stock } = useSelector(state => state.crossReference)
    const [quantities, setQuantities] = useState({});
    const [cartLoading, setLoadingCart] = useState({});
    const [scheduleLoading, setScheduleloading] = useState({})
    const [limit, setLimit] = useState(10)
    const { selectedData } = useSelector(state => state.compare)

    const product = products?.data
    const totalPages = products?.totalPages
    const totalItems = products?.totalItems
    const itemsPerPage = products?.limit
    const [sortBy, setSortBy] = useState('productOverview.productNumber')
    const [order, setOrder] = useState('desc')

    // calculate start & end of items -------------------
    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;

    const searchProduct = (e) => {
        e.preventDefault()
        dispatch(getcrossProductThunk(`?search=${search}&page=${page}&limit=${limit}`))
    }

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchParams({ search: value });
    };

    useEffect(() => {
        const stats = status ? 'ACTIVE' : ""
        const stocks = stock ? 'true' : ''
        if (search.length > 0) {
            dispatch(getcrossProductThunk(`?search=${search}&page=${page}&limit=${limit}&status=${stats}&stock=${stocks}&sortBy=${sortBy}&order=${order}`))
        }
    }, [status, stock, sortBy, order, page])

    useEffect(() => {
        if (search.length <= 0) {
            dispatch(setCrossProducts())
        }
    }, [search])

    const addtoCart = async (from, productId) => {
        const products = Object.entries(quantities).map(([id, quantity]) => ({
            productId: id,
            quantity: parseInt(quantity, 10),
            totalQty: parseInt(quantity, 10)
        }));
        if (from === 'cart') {
            setLoadingCart((prev) => ({ ...prev, [productId]: true }));
            // Add import/thunk dispatch logic if cartSlice is used
            setLoadingCart((prev) => ({ ...prev, [productId]: false }));
        }
        else {
            setScheduleloading((prev) => ({ ...prev, [productId]: true }));
            // Add import/thunk dispatch logic if scheduleSlice is used
            setScheduleloading((prev) => ({ ...prev, [productId]: false }));
        }
    }

    const handleQuantityChange = (productId, value) => {
        setQuantities((prev) => ({
            ...prev,
            [productId]: value,
        }));
    };

    const handleCheckboxChange = (product) => {
        dispatch(toggleProductSelection(product));
    };

    return (
        <>
            <div className={styles.imgBread}>
                <span>Cross Reference</span>
            </div>

            <div className={styles.crossContainer}>
                <div className={styles.crossSearch}>
                    <p>Use this tool to find alternate parts and products. Easily compare part similarities and differences. See examples: LM358MNOPB, NCP551SN33T1G or B37872K9105K62</p>
                    <br />
                    <h3> Cross reference search</h3>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '30px', width: '100%' }}>
                        <form className={styles.searchContainer} onSubmit={searchProduct}>
                            <input
                                type="text"
                                placeholder="Enter part #"
                                className={styles.searchInput}
                                onChange={handleInputChange}
                                value={search}
                            />
                            <button className={styles.searchBtn} type='submit' disabled={loading} style={{ background: loading ? '#9573e6' : '#512DA8' }}>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.33488 11.0342C4.23694 11.68 5.29827 12.0252 6.38462 12.0252C7.10587 12.0252 7.81987 11.873 8.48579 11.5774C9.15169 11.2819 9.75628 10.849 10.2652 10.3037C10.7742 9.75837 11.1775 9.11138 11.4526 8.39981C11.7277 7.68824 11.8692 6.92579 11.8692 6.15596C11.8692 4.99661 11.5484 3.86278 10.9466 2.89782C10.3448 1.93281 9.48872 1.17957 8.48579 0.734475C7.48276 0.289331 6.37861 0.17273 5.31329 0.399772C4.24804 0.626799 3.27055 1.18697 2.50402 2.00826C1.73755 2.82947 1.21627 3.87496 1.00515 5.01218C0.794022 6.14939 0.902328 7.3282 1.31661 8.39981C1.73091 9.47145 2.43291 10.3885 3.33488 11.0342ZM4.04961 2.39971C4.74144 1.90443 5.55402 1.64057 6.38462 1.64057C7.49826 1.64057 8.5678 2.11449 9.35752 2.96062C10.1474 3.80697 10.5923 4.95626 10.5923 6.15596C10.5923 7.05049 10.3447 7.92443 9.88149 8.66721C9.4183 9.40994 8.76066 9.98773 7.99254 10.3286C7.22453 10.6695 6.37988 10.7585 5.56508 10.5849C4.75021 10.4112 4.00069 9.98233 3.41173 9.3513C2.8227 8.7202 2.42087 7.91532 2.25802 7.03812C2.09516 6.16091 2.1788 5.25172 2.4981 4.42578C2.81739 3.59988 3.35768 2.89507 4.04961 2.39971Z" fill="white" stroke="#512DA8" stroke-width="0.2" />
                                    <path d="M14.4588 15.4864C14.5436 15.4869 14.6274 15.4694 14.7054 15.4352C14.7836 15.401 14.8543 15.3507 14.9136 15.2877C14.973 15.2245 15.0198 15.1497 15.0517 15.0677C15.0835 14.9858 15.0999 14.8981 15.0999 14.8097C15.0999 14.7213 15.0835 14.6337 15.0517 14.5517C15.0199 14.4698 14.9731 14.3951 14.9137 14.3319C14.9137 14.3319 14.9136 14.3318 14.9136 14.3318L10.6104 9.71858C10.5513 9.65523 10.4808 9.60457 10.4026 9.56987C10.3245 9.53516 10.2404 9.51719 10.1554 9.51719C10.0703 9.51719 9.98625 9.53516 9.90808 9.56987C9.82994 9.60457 9.7594 9.65523 9.70031 9.71858C9.64123 9.78191 9.5947 9.85673 9.56307 9.9386C9.53144 10.0205 9.51523 10.108 9.51523 10.1962C9.51523 10.2845 9.53144 10.372 9.56307 10.4539C9.5947 10.5357 9.64123 10.6106 9.70031 10.6739L14.0037 15.2874L14.004 15.2877C14.0633 15.3507 14.134 15.401 14.2122 15.4352C14.2902 15.4694 14.3741 15.4869 14.4588 15.4864ZM14.4588 15.4864C14.4586 15.4864 14.4584 15.4864 14.4582 15.4864L14.4588 15.3864L14.4594 15.4864C14.4592 15.4864 14.459 15.4864 14.4588 15.4864Z" fill="white" stroke="#512DA8" stroke-width="0.2" />
                                </svg>
                                Search
                            </button>
                        </form>
                        {loading &&
                            <div>
                                <img src="/assets/__Iphone-spinner-1.gif" alt="" style={{ width: 35, height: 35 }} />
                            </div>
                        }
                    </div>

                    {product?.length > 0 && (
                        <div className={styles.subCatcheckCol}>
                            <div className={styles.displayFlex}>
                                <input type="checkbox" onChange={() => dispatch(setcrossStatus())} checked={status} /> <span>Is Active</span>
                            </div>
                            <div className={styles.displayFlex}>
                                <input
                                    type="checkbox"
                                    onChange={() => dispatch(setcrossStock())}
                                    checked={stock}
                                /> <span>In stock</span>
                            </div>
                        </div>
                    )}
                </div>

                <div className={styles.toolListing}>
                    <span> Tool Overview</span> <br />
                    <p>Electrowiz cross reference tool is intended to simplify the search for substitute parts by providing a list of parametrically similar part options. To use the tool:</p>
                    <ul>
                        <li>
                            Enter a Complete manufacturer part number into the search field
                        </li>
                        <li>
                            Available results are displayed in a table with the searched part in the top row and columns including part parameters for easy comparison
                        </li>
                        <li>
                            Cells highlighted in Green indicate the parameter in the column for that part is an exact match to the searched part
                        </li>
                        <li> The checkbox located in the far left column allows easy comparison of 2 or more parts
                        </li>
                    </ul>
                    <p style={{ marginTop: '10px' }}> Each column allows sorting, custom filtering, and manipulation such as moving, sizing or pinning.</p>
                </div>
            </div>

            {product?.length > 0 && (
                <>
                    <SortCrossRefer productlength={product?.length} />

                    <ProductTable
                        products={product}
                        quantities={quantities}
                        addtoCart={addtoCart}
                        handleQuantityChange={handleQuantityChange}
                        handleCheckboxChange={handleCheckboxChange}
                        cartLoading={cartLoading}
                        scheduleLoading={scheduleLoading}
                        selectedProducts={selectedData}
                    />
                    <CatPagination
                        start={start}
                        end={end}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        setPage={setcrossProductPage}
                        page={page}
                    />
                </>
            )}
        </>
    )
}

export default CrossRefer